import userCenter from '../../api/userCenter'

const state = {
  informData: {
    state: true,
    totalElements: 0,
    content: []
  },
  capitalRecords: {
    state: true,
    totalElements: 0,
    content: []
  },
  usedCoupons: { // 已使用
    state: true,
    totalElements: 0,
    content: []
  },
  unusedCoupons: { // 未使用
    state: true,
    totalElements: 0,
    content: []
  },
  expireCoupons: { // 过期
    state: true,
    totalElements: 0,
    content: []
  },
  queryQrCode: null,
  recommendRecord: {
    state: true,
    totalElements: 0,
    content: []
  },
  invoiceRecord: {
    state: true,
    totalElements: 0,
    content: []
  },
  imformNum: {
    num: 0,
    content: ''
  },
  customerPreSave: {}, // 用户余额
  infoData: '',
  djCoupns: [], // v5代驾券
  zcCoupons: [], // v5优惠券
  allCoupons: [], // v5所有优惠券
  unUsedCoupon: [], // V5未使用的优惠券
  usedCoupon: [], // V5已使用的优惠券
  expireCoupon: [] // V5已过期的优惠券
}

const mutations = {
  getInform (state, data) {
    state.informData.state = false
    if (data.type === 'upData') {
      state.informData.content = []
    }
    let Data = data.data
    if (Data) {
      state.informData.totalElements = Data.totalElements
      for (let i = 0; i < Data.content.length; i++) {
        state.informData.content.push(Data.content[i])
      }
    }
  },
  v5getCouponsMutations (state, data) { // v5获取优惠券
    if (data && data.code === 1) {
      let allCoupon = data.coupon
      let zcCoupon = []
      let djCoupn = []
      let unUsedCoupon = []
      let usedCoupon = []
      let expireCoupon = []
      if (allCoupon && allCoupon.length > 0) {
        allCoupon.forEach(function (row) {
          // 分业务
          if (row.main_service_type === 'zhuanche') {
            zcCoupon.push(row)
          }
          if (row.main_service_type === 'daijia') {
            djCoupn.push(row)
          }
          // 分使用过与未使用过
          if (row.state === 1) {
            unUsedCoupon.push(row)
          }
          if (row.state === 2) {
            usedCoupon.push(row)
          }
          if (row.state === 3) {
            expireCoupon.push(row)
          }
        })
      }
      state.djCoupns = djCoupn
      state.zcCoupons = zcCoupon
      state.unUsedCoupon = unUsedCoupon
      state.usedCoupon = usedCoupon
      state.expireCoupon = expireCoupon
      state.allCoupons = allCoupon
    } else {
      // this.hintBox = {
      //   stateShow: true,
      //   state: 'no',
      //   content: data.msg
      // }
    }
  },
  capitalRecords (state, data) {
    let Data = data.data
    state.capitalRecords.totalElements = Data.totalElements
    if (data.type === 'upData') {
      state.capitalRecords.content = []
    }
    state.capitalRecords.content = Data.content.reduce((callback, item) => {
      callback.push(item)
      return callback
    }, state.capitalRecords.content)
    state.capitalRecords.state = false
  },
  // usedCoupons (state, data) {
  //   if (data.typeFn === 'upData') {
  //     state.usedCoupons.content = []
  //     // console.log(state.usedCoupons.content)
  //   }
  //   state.usedCoupons.totalElements = data.data.totalElements
  //   state.usedCoupons.content = data.data.content.reduce((callback, item) => {
  //     callback.push(item)
  //     return callback
  //   }, state.usedCoupons.content)
  // },
  // unusedCoupons (state, data) {
  //   if (data.typeFn === 'upData') {
  //     state.unusedCoupons.content = []
  //   }
  //   state.unusedCoupons.totalElements = data.data.totalElements
  //   state.unusedCoupons.content = data.data.content.reduce((callback, item) => {
  //     callback.push(item)
  //     return callback
  //   }, state.unusedCoupons.content)
  // },
  // expireCoupons (state, data) {
  //   if (data.typeFn === 'upData') {
  //     state.expireCoupons.content = []
  //   }
  //   state.expireCoupons.totalElements = data.data.totalElements
  //   state.expireCoupons.content = data.data.content.reduce((callback, item) => {
  //     callback.push(item)
  //     return callback
  //   }, state.expireCoupons.content)
  // },
  queryQrCode (state, data) {
    state.queryQrCode = data
  },
  queryRecommendRecord (state, data) {
    let Data = data.data
    state.recommendRecord.totalElements = Data.totalElements
    if (data.type === 'upData') {
      state.recommendRecord.content = []
    }
    state.recommendRecord.content = Data.content.reduce((callback, item) => {
      callback.push(item)
      return callback
    }, state.recommendRecord.content)
  },
  invoiceRecord (state, data) {
    if (data.type === 'upData') {
      state.invoiceRecord.content = []
    }
    let Data = data.data.data
    state.invoiceRecord.totalElements = Data.totalElements
    state.invoiceRecord.content = Data.content.reduce((callback, item) => {
      callback.push(item)
      return callback
    }, state.invoiceRecord.content)
  },
  imformNum (state, data) {
    let dataNum = data.data
    if (dataNum && dataNum.replace(',').length > 99) {
      state.imformNum.num = '99+'
    } else {
      state.imformNum.num = dataNum.split(',').length
    }
    state.imformNum.content = dataNum
    if (data.fn) {
      data.fn()
    }
  },
  postCustomerPreSave (state, data) { // 用户余额
    if (data.data.code === 1) {
      state.customerPreSave = data.data.customerPreSave
      if (data.fn) {
        data.fn(data.data.customerPreSave)
      }
    }
  }
}

const getters = {
  getInform: state => {
    return state.informData
  },
  djCoupnsGetter: state => { // 代驾优惠券
    return state.djCoupns
  },
  zcCouponsGetter: state => { // 优惠券
    return state.zcCoupons
  },
  unUsedCouponGetter: state => {
    return state.unUsedCoupon
  },
  usedCouponGetter: state => {
    return state.usedCoupon
  },
  expireCouponGetter: state => {
    return state.expireCoupon
  },
  capitalRecords: state => {
    return state.capitalRecords
  },
  usedCoupons: state => { // 已使用
    return state.usedCoupons
  },
  unusedCoupons: state => { // 未使用
    return state.unusedCoupons
  },
  expireCoupons: state => { // 过期
    return state.expireCoupons
  },
  allCouponsGetter: state => { // 所有优惠券
    return state.allCoupons
  },
  queryQrCode: state => {
    return state.queryQrCode
  },
  queryRecommendRecord: state => {
    return state.recommendRecord
  },
  invoiceRecord: state => {
    return state.invoiceRecord
  },
  imformNum: state => {
    return state.imformNum
  },
  postCustomerPreSave: state => state.customerPreSave // 个人余额
}

const actions = {
  getInform ({commit}, obj) { // 通知查询
    userCenter.inform(obj, (data) => {
      commit('getInform', {type: obj.type, data: data})
    })
  },
  v5getCoupons ({commit}, obj) { // v5获取优惠券
    userCenter.getCouponsApi(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      commit('v5getCouponsMutations', data)
    })
  },
  postCustomerPreSave ({commit}, obj) { // 获取用户余额
    userCenter.postCustomerPreSave(obj, (data) => {
      commit('postCustomerPreSave', {type: obj.type, data: data})
    })
  },
  getCustomerPreSaveSerials ({commit}, obj) { // 资金流水
    userCenter.getCustomerPreSaveSerials(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      // commit('getCustomerPreSaveSerials', {type: obj.type, data: data.data})
    })
  },
  addCoupon ({commit}, obj) { // 添加优惠券
    userCenter.addCoupon(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  queryCoupons ({commit}, obj) { // 查询优惠券
    userCenter.queryCoupons(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      commit(obj.type, {typeFn: obj.typeFn, data: data.data})
    })
  },
  findNearDrivers ({commit}, obj) { // v5查询附近司机
    userCenter.findNearDrivers(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  amendPersonalData ({commit}, obj) {
    userCenter.amendPersonalData(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  queryQrCode ({commit}, obj) {
    userCenter.qrCode(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      commit('queryQrCode', data.data)
    })
  },
  queryRecommendRecord ({commit}, obj) {
    userCenter.recommendRecord(obj, (data) => {
      commit('queryRecommendRecord', {type: obj.type, data: data.data})
    })
  },
  invoiceApply ({commit}, obj) {
    userCenter.invoiceApply(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  getInvoiceOrders ({commit}, obj) { // 发票列表
    userCenter.getInvoiceOrders(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  imformNum ({commit}, obj) {
    userCenter.imformNum(obj, (data) => {
      commit('imformNum', {fn: obj.fn, data: data.data})
    })
  },
  upImformNum ({commit}, obj) {
    userCenter.upImformNum(obj, (data) => {
    })
  },
  userSumPay ({commit}, obj) {
    userCenter.userSumPay(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  Articlebyalias ({commit}, obj) {
    userCenter.Articlebyalias(obj, (data) => {
      obj.fn(data)
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userCenter.js